import { Container, makeStyles, Typography, Box, Grid, Button } from '@material-ui/core';
import React from 'react'
import RouterLink from '../react_router/RouterLink';
import { GAME } from '../../private/routes';
import { BLACK, WHITE } from '../../style/colors';

const useStyles = makeStyles((theme) => ({
  header: {
    textAlign: 'center'
  },
  subtitle: {
    textAlign: 'center'
  }
}))

function Area({ children, bgcolor, color, bgimage }) {
  return <Box bgcolor={bgcolor} color={color} 
  p={2}
  style={{
    backgroundImage: `url(${bgimage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  }}
  >
    {children}
  </Box>
}

export default function ProdAbout() {
  const css = useStyles()
  return <Box component="div" maxWidth="xs" p={0}>
    <Area bgcolor={WHITE} color={BLACK} bgimage='paper2.png'>
      <Typography variant='h2' className={css.header}>Serve Your <br /> Nation</Typography>
      <Typography className={css.subtitle} >
        Become a Spy and Take Part in the War for Independence
      </Typography>
    {/* </Area>
    <Area> */}
    <br/>
      <Container>
        <Grid container align = "center" justify = "center" alignItems = "center" >
          <Grid item>
            <RouterLink route href={`${GAME}`}>
              <Button variant="contained"
                color="primary"> play now </Button>
            </RouterLink>
          </Grid>
        </Grid>
      </Container>
    <br/>
    {/* </Area>
    <Area bgcolor={BLACK} color={WHITE}> */}
      <Typography variant='h5'>Choose A Side</Typography>
      <Typography paragraph>
        Join the Americans to spy for freedom and enlightenment.
        Join the British to spy for King and Country.
      </Typography>
      <Typography variant='h5'>Get Your Assignment</Typography>
      <Typography paragraph>
        This game is mostly text based, meaning you will receive instruction from
        your contact. These instructions involve
        interacting with the real world and real people.
      </Typography>
      <Typography variant='h5'>Decide Your Fate</Typography>
      <Typography paragraph>
        Once you accomplish the assigned task, you will report what happened and
        receive a new task. This pattern will continue until you do all the tasks
        in a mission are complete. <br /> Similar to a choose-your-own-adventure novel,
        the responses you select will limit the available
        options and tasks in the future.
      </Typography>
    </Area>
  </Box>
}